import styled from 'styled-components';
import logoImg from '../../assets/logo-myshop.png';
import * as colors from '../../config/colors';

export const StatusBadge = styled.div`
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(p) => (p.$online ? '#10b981' : '#ef4444')};
  border: 2px solid white;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  z-index: 2;
`;

export const UserPhoto = styled.img.attrs(() => ({
  src: logoImg,
  alt: 'Foto do usuário',
}))`
  width: ${(p) => (p.$collapsed ? '40px' : '48px')};
  height: ${(p) => (p.$collapsed ? '40px' : '48px')};

  border-radius: 50%;
  border: 2px solid ${colors.primaryDarkColor};
  background-color: white;

  object-fit: contain;
  flex-shrink: 0;
  display: block;
  transition: all 220ms cubic-bezier(0.2, 0, 0, 1);
  cursor: pointer;

  &:hover {
    border-color: ${colors.primaryColor};
    transform: scale(1.05);
  }
`;

export const UserNavContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: ${(p) => (p.$collapsed ? '16px 0' : '20px 0')};
  padding: ${(p) => (p.$collapsed ? '0' : '0')};
  transition: all 220ms cubic-bezier(0.2, 0, 0, 1);

  /* === GUEST (não logado) === */
  .guest-container {
    display: flex;
    flex-direction: ${(p) => (p.$collapsed ? 'column' : 'row')};
    align-items: center;
    gap: ${(p) => (p.$collapsed ? '8px' : '12px')};
    padding: ${(p) => (p.$collapsed ? '12px 8px' : '16px')};
    background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
    border-radius: 12px;
    border: 1px solid #d1d5db;
  }

  .guest-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(p) => (p.$collapsed ? '40px' : '48px')};
    height: ${(p) => (p.$collapsed ? '40px' : '48px')};
    border-radius: 50%;
    background-color: white;
    color: #9ca3af;
    border: 2px solid #d1d5db;
  }

  .guest-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .guest-title {
    font-size: 0.875rem;
    font-weight: 600;
    color: #4b5563;
    margin: 0;
  }

  .guest-subtitle {
    font-size: 0.75rem;
    color: #6b7280;
    margin: 0;
  }

  /* === USER FRAME (logado) === */
  .user-frame {
    display: flex;
    flex-direction: column;
    background: linear-gradient(135deg, ${colors.primaryDarkColor} 0%, #595959 100%);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .user-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px;
    cursor: pointer;
    transition: background-color 180ms ease;
    position: relative;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }

    &:active {
      background-color: rgba(255, 255, 255, 0.08);
    }
  }

  .user-avatar-wrapper {
    position: relative;
    flex-shrink: 0;

    ${(p) =>
      p.$collapsed &&
      `
      margin: 0 auto;
    `}
  }

  .user-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .user-name {
    font-size: 0.8rem;
    font-weight: 600;
    color: white;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;
  }

  .user-role {
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
    font-weight: 400;
    font-size: 0.7rem;
    line-height: 1.2;
  }

  .dropdown-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.7);
    transition: color 180ms ease, transform 180ms ease;

    &:hover {
      color: white;
    }
  }

  /* Estado colapsado */
  ${(p) =>
    p.$collapsed &&
    `
    align-items: center;
    justify-content: center;
  `}

  /* === DROPDOWN WRAPPER (transição suave) === */
  .dropdown-wrapper {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 400ms cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
  }

  .dropdown-wrapper.open {
    grid-template-rows: 1fr;
  }
`;

export const UserDropdown = styled.div`
  min-height: 0; /* Crucial para o grid funcionar */
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.05);
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  .user-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.8rem;
  }

  .detail-label {
    color: rgba(255, 255, 255, 0.6);
    font-weight: 500;
  }

  .detail-value {
    color: white;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    background-color: rgba(255, 255, 255, 0.1);
    padding: 2px 8px;
    border-radius: 4px;
  }

  /* Ações da conta do próprio usuário (perfil, senha). Ficam aqui, e não no
     grupo "Configurações" da sidebar, porque aquele grupo é gateado por
     permissões de IAM — esconderia a própria conta justamente de quem não é
     administrador. Estas rotas não têm RBAC. */
  .account-link {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 11px 14px;

    border: none;
    background-color: transparent;
    color: rgba(255, 255, 255, 0.82);
    font-size: 0.85rem;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    transition: all 180ms ease;

    &:hover {
      background-color: rgba(237, 237, 237, 0.1);
      color: #ffffff;
      text-decoration: none;
    }
  }

  .account-actions {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .logout-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 12px 14px;
    border: none;
    background-color: transparent;
    color: #fca5a5;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 180ms ease;

    &:hover {
      background-color: rgba(237, 237, 237, 0.1);
      color: #ffcaca;
    }

    &:active {
      background-color: rgba(68, 94, 239, 0.15);
    }

    svg {
      transition: transform 180ms ease;
    }

    &:hover svg {
      transform: translateX(2px);
    }
  }
`;
